import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor() {}

  /**
   * Triggers an event in the client's browser to download the provided blob data
   * @param data blob data to save
   * @param fileName name of file
   * @param type type of file
   */
  saveFile(data: any, fileName: string, type: string) {
    const blob = new Blob(data, { type: type });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // edge/ie fix for downloading blob data
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const anchor = document.createElement('a');
      anchor.setAttribute('href', URL.createObjectURL(blob));
      anchor.setAttribute('download', fileName || 'blob');
      anchor.dispatchEvent(new MouseEvent('click'));
    }
  }

  /**
   * Reads a File object and returns the contents in a Promise as javascript object.
   * @param file JSON file
   */
  readJsonFile(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = event => {
        const contents: string = reader.result as string;
        try {
          const obj = JSON.parse(contents);
          resolve(obj);
        } catch {
          reject(new Error('Invalid import file format'));
        }
      };

      reader.onerror = event => {
        reject(new Error('Failed to read import file'));
      };

      reader.readAsText(file);
    });
  }
}
